import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    lenisRef.current?.scrollTo(target, { offset: -200, duration: 1.6 });
  };

  return (
    <div className="App bg-ink font-sans text-fog antialiased">
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Services />
        <Stats />
        <Testimonials />
        <Contact />
      </main>
      <Footer onNavigate={scrollTo} />
    </div>
  );
}
